import { Record } from 'immutable';

export default class WeeklyBookingRecord extends Record({
  id: null,
  year: null,
  week: null,
  resourceFeesPerHour: null,
  customerFeesPerHour: null,
  overriddenCustomerFee: null,
  overriddenResourceFee: null,
  isForSelfEmployed: false,
  isReported: false,
  isInvoiced: false,
  booked: null,
  reported: null,
  booking: null,
  bookingResource: null,
  resource: null,
  services: null,
  customer: null,
  createdBy: null,
  staffingCompany: null,
}) {
}
